import useSWR from 'swr';

import { fetchUpcomingObligations, type Obligation } from '../data/recurringRepository.js';

/** Shared so a confirm anywhere can refresh every list showing the same horizon. */
export const OBLIGATIONS_KEY = 'obligations';

/**
 * How far ahead "Đến hạn" looks: an occurrence due on the 5th first shows on the 1st (decision
 * AK1). Fourteen days put half a month of bills on the card at once, so it read as a calendar
 * rather than a list of things to do this week.
 */
export const OBLIGATION_HORIZON_DAYS = 4;

export type ObligationsState =
  | { status: 'loading' }
  | { status: 'error'; message: string; retry: () => void }
  | { status: 'ready'; obligations: readonly Obligation[]; refresh: () => Promise<unknown> };

export function useObligations(from: string | null, days = OBLIGATION_HORIZON_DAYS) {
  const { data, error, isLoading, mutate } = useSWR<readonly Obligation[], Error>(
    from === null ? null : `${OBLIGATIONS_KEY}:${from}:${days}`,
    () => fetchUpcomingObligations(from!, days),
    { revalidateOnFocus: false, shouldRetryOnError: false },
  );

  if (error) {
    return {
      status: 'error' as const,
      message: error.message || 'Không tải được danh sách khoản đến hạn.',
      retry: () => {
        void mutate();
      },
    };
  }
  if (isLoading || data === undefined) return { status: 'loading' as const };

  return { status: 'ready' as const, obligations: data, refresh: () => mutate() };
}
